export const DEFAULT_SCENE = 'administration:schedule-elements';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;

// Schedule elements list
const LIST_OF_SCHEDULE_ELEMENTS = `${DEFAULT_SCENE}:list-of-schedule-elements`;
export const LIST_OF_SCHEDULE_ELEMENTS_CONTAINER_TAG = `${LIST_OF_SCHEDULE_ELEMENTS}:container`;
export const getScheduleElementPropTag = (propName: string, propId: string) =>
  `${LIST_OF_SCHEDULE_ELEMENTS}:schedule-element-${propName}:${propId}`;

// Search Schedule elements
const SEARCH_SCHEDULE_ELEMENTS = `${DEFAULT_SCENE}:filter-schedule-elements`;
export const SEARCH_SCHEDULE_ELEMENTS_CONTAINER_TAG = `${SEARCH_SCHEDULE_ELEMENTS}:container`;

export const getSearchFieldsInputTag = (fieldName: string) => `${SEARCH_SCHEDULE_ELEMENTS}:input-${fieldName}`;

// Detail (Create / Edit) Sidebar
const SIDEBAR_DETAIL_SCHEDULE_ELEMENT = `${DEFAULT_SCENE}:detail-sidebar`;
export const BUTTON_TOGGLE_SCHEDULE_ELEMENT_DETAIL_SIDEBAR = `${SIDEBAR_DETAIL_SCHEDULE_ELEMENT}:button-toggle`;
export const BUTTON_SUBMIT_SCHEDULE_ELEMENT = `${SIDEBAR_DETAIL_SCHEDULE_ELEMENT}:button-submit`;
export const BUTTON_CANCEL_SCHEDULE_ELEMENT = `${SIDEBAR_DETAIL_SCHEDULE_ELEMENT}:button-cancel`;
export const SCHEDULE_ELEMENT_INPUT_FIELD = `${SIDEBAR_DETAIL_SCHEDULE_ELEMENT}:text-input`;
export const SCHEDULE_ELEMENT_MESSAGE = `${SIDEBAR_DETAIL_SCHEDULE_ELEMENT}:message`;
